//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import productDocumentsQuery from '~/apollo/queries/documents/product-documents'
import filterResults from '~/mixins/filter-results'

export default {
  mixins: [filterResults],
  data () {
    return {
      fetched: false,
      fetchedSoftware: false
    }
  },
  props: {
    productId: String,
    productInternalName: String
  },
  apollo: {
    productDocuments: {
      prefetch: true,
      query: productDocumentsQuery,
      result ({ data, loading, networkStatus }) {
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    }
  },
  async fetch () {
    this.software = await this.$http.$get(this.$config.motecOnlineUrl + '/ResourceDownload/ResourcesForProduct?type=Software&products=' + encodeURI(this.productInternalName))
      .then((response) => {
        this.fetchedSoftware = true
        return response
      })
      .catch((e) => {
        console.log(e.toJSON())
        this.fetchedSoftware = true
      })
  },
  fetchOnServer: false,
  computed: {
    subcategoriesAndDocuments () {
      const ret = []
      const uploads = []
      if (this.productDocuments && this.productDocuments.data) {
        this.productDocuments.data.forEach((subcategory) => {
          let retSubcategory = ret.find(el => el.name === subcategory.attributes.name)
          if (!retSubcategory) {
            ret.push({ name: subcategory.attributes.name, files: [] })
            retSubcategory = ret[ret.length - 1]
          }
          subcategory.attributes.files.forEach((file) => {
            if (file.products.data.find(el => el.id === this.productId) && !uploads.find(el => el === file.file.data.attributes.url)) {
              const files = retSubcategory.files
              files.push(file)
              uploads.push(file.file.data.attributes.url)
            }
          })
        })
        return ret
      } else {
        return null
      }
    }
  }
}
